import React from "react";

import CsLineIcons from "../../cs-line-icons";

class Label extends React.Component {
    render() {
        const __icon = this.props.icon;
        const __caption = this.props.caption;

        return (
            <>
                {__icon ? (
                    <CsLineIcons icon={__icon} className="cs-icon icon" style={{ paddingRight: "5px" }} />
                ) : (
                    ``
                )}
                <span className="label" > {__caption}</span >
            </>
        )

    }
}

export default Label;